import { Slider } from './Slider';
import { VirtualizeSlider } from './VirtualizeSlider';
import { withControls } from './withControls';
import { bindKeyboard } from './reactSwipeableViews';
import { VirtualizeSliderProps } from './types';

export type ControlProps = import('./types').ControlProps;
export type SlideRendererParams = import('./types').SlideRendererParams;
export type SlideRenderer = import('./types').SlideRenderer;

export const SliderWithControls = withControls(Slider);
export const VirtualizeSliderWithControls = withControls<VirtualizeSliderProps>(
  bindKeyboard(VirtualizeSlider),
);
